// extracted by mini-css-extract-plugin
export default {"wrapper":"Vda-z","play":"Wda-z"};